import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTrigger } from "@/components/ui/dialog";
import { readLastMood, subscribeMood, moodEmoji } from '@/lib/moodBus';
const InfoDialog = ({
  isOpen,
  onOpenChange,
  triggerClassName = "",
}) => {
  const [mood, setMood] = useState(() => readLastMood());
  useEffect(() => subscribeMood(setMood), []);
  const emoji = moodEmoji(mood || {});
  return <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <button
          aria-label="About"
          className={`inline-flex items-center justify-center text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors ${triggerClassName}`}
        >
          <span role="img" aria-label="info" className="text-xl leading-none">{emoji}</span>
        </button>
      </DialogTrigger>
      <DialogContent className="p-4 shadow-lg max-w-sm w-[calc(100vw-2rem)] sm:w-full max-h-[80vh] overflow-y-auto rounded-3xl px-[10px] py-[10px] mx-0 my-[5px] bg-inherit">
        <DialogHeader>
        </DialogHeader>
        <div className="space-y-4 text-base text-gray-600 dark:text-gray-300">
          <p className="flex items-center gap-1">
            Made with 🌻 in Sweden 🇸🇪 by{' '}
            <a href="https://www.linkedin.com/in/viq/" target="_blank" rel="noopener noreferrer" className="text-gray-800 dark:text-gray-200 hover:underline">
              Vijith
            </a>
          </p>
          <p>
            Weather data provided by{' '}
            <a href="https://open-meteo.com/" target="_blank" rel="noopener noreferrer" className="text-gray-800 dark:text-gray-200 hover:underline">
              Open Meteo
            </a>
          </p>
        </div>
      </DialogContent>
    </Dialog>;
};
export default InfoDialog;